import React, { useState } from "react";
import UsersList from "../../components/Admin/Users/UsersList";
import MainLayout from "../../components/Layouts/MainLayout";
import { FiUsers, FiUserPlus } from "react-icons/fi";
import { BsGrid3X3Gap, BsList } from "react-icons/bs";

import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';

function Users() {
  const [viewMode, setViewMode] = useState("cards");

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
        <div className="p-4 md:ml-64 pt-20">
          {/* Enhanced Header Section */}
          <div className="max-w-7xl mx-auto mb-8">
            <div className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-xl rounded-3xl shadow-sm border border-white/20 dark:border-gray-700/30 p-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                {/* Title Section */}
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-r from-green-500 to-teal-500 rounded-2xl shadow-lg">
                    <FiUsers className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-300 bg-clip-text text-transparent">
                      User Management
                    </h1>
                    <p className="text-gray-600 dark:text-gray-400 mt-1 text-lg">
                      Manage and monitor your team members
                    </p>
                  </div>
                </div>
                
                {/* View Mode Toggle */}
                <div className="flex items-center gap-4">
                  <div className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-xl p-1">
                    <button
                      onClick={() => setViewMode("cards")}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                        viewMode === "cards"
                          ? "bg-white dark:bg-gray-600 shadow-md text-green-600 dark:text-green-400"
                          : "text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
                      }`}
                    >
                      <BsGrid3X3Gap className="w-4 h-4" />
                      <span className="text-sm font-medium">Cards</span>
                    </button>
                    <button
                      onClick={() => setViewMode("table")}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                        viewMode === "table"
                          ? "bg-white dark:bg-gray-600 shadow-md text-green-600 dark:text-green-400"
                          : "text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
                      }`}
                    >
                      <BsList className="w-4 h-4" />
                      <span className="text-sm font-medium">Table</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Users List Component */}
          <div className="max-w-7xl mx-auto">
            <UsersList viewMode={viewMode} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Users;